<template>
  <b-card title="تایید شماره شبا">
    <div class="row">
      <div class="col-md-8">
        <h3>اطلاعات حساب</h3>
        <div class="row">
          <div class="col-md-3" v-if="userCard.bank_name != null">
            <b-img
              fluid
              :src="
                routesMap.BankImage +
                  userCard.bank_name.latin_code +
                  '-300-c.png'
              "
            ></b-img>
          </div>
          <div class="col-md-9">
            <h4>{{ userCard.shaba_number }}</h4>
            <b-form-group label="نام مالک حساب:">
              <!-- {{ userCard.nickname }} -->
              <b-form-input
                id="input-7"
                v-model="userCard.nickname"
                required
                placeholder="نام مالک حساب"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="شماره حساب:">
              <!-- {{ userCard.nickname }} -->
              <b-form-input
                id="input-7"
                v-model="userCard.account_number"
                required
                placeholder="شماره حساب"
              ></b-form-input>
            </b-form-group>
            <div>
              <b-button ref="estelam1" variant="info" @click="estelam"
                >استعلام</b-button
              >&nbsp;
              <b-button
                v-if="userCard.mdid8_status != 1571"
                variant="success"
                @click="editConfirmSheba(1)"
                >تایید</b-button
              >&nbsp;
              <b-button
                v-if="userCard.mdid8_status != 1571"
                variant="danger"
                @click="editConfirmSheba(2)"
                >عدم تایید</b-button
              >&nbsp;
              <b-button variant="primary" @click="editConfirmSheba(3)"
                >ذخیره</b-button
              >&nbsp;
              <b-button variant="secondary" @click="editConfirmSheba(4)"
                >ارسال به شرکای تجاری</b-button
              >&nbsp;
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <h3>اطلاعات مالک</h3>
        <b-form-group label="نام و نام خانوادگی:">
          <div class="form-control">
            {{ userCard.user.name }}
          </div>
        </b-form-group>
        <b-form-group label="کد ملی:">
          <div class="form-control">
            {{ userCard.user.national_card_number }}
          </div>
        </b-form-group>
      </div>

      <div class="col-md-12" v-if="estelamResult != null">
        <h3>نتیجه استعلام</h3>
        <b-form-group label="شماره شبا:">
          <div class="form-control">
            {{ estelamResult.IBAN }}
          </div>
        </b-form-group>
        <b-form-group label="نام بانک:">
          <div class="form-control">
            {{ estelamResult.bankName }}
          </div>
        </b-form-group>
        <b-form-group label="شماره حساب:">
          <div class="form-control">
            {{ estelamResult.deposit }}
          </div>
        </b-form-group>
        <b-form-group label="توضیحات حساب:">
          <div class="form-control">
            {{ estelamResult.depositComment }}
          </div>
        </b-form-group>
        <b-form-group label="مالکان:">
          <div
            class="form-control"
            v-for="x in estelamResult.depositOwners"
            v-bind:key="x.firstName + x.lastName"
          >
            {{ x.firstName + " " + x.lastName }}
          </div>
        </b-form-group>
      </div>
    </div>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import routesMap from "../../helpers/routesMap";
export default {
  name: "confirmSheba",
  data() {
    return {
      userCard: {
        user: {},
      },
      userCardSend: {},
      estelamResult: null,
      routesMap
    };
  },
  mounted() {
    this.getdata();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست شباها",
        route: "/sheba",
      },
      {
        title: "تایید شماره شبا",
      },
    ]);
  },
  methods: {
    estelam() {
      this.$refs["estelam1"].classList.add(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      httpHelper
        .getData("finotech?sheba=" + this.userCard.shaba_number)
        .then((res) => {
          this.estelamResult = res.data;
          this.$refs["estelam1"].classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    editConfirmSheba(state) {
      this.userCardSend = {};
      this.userCardSend.id = this.userCard.id;
      if (state == 1) {
        this.userCardSend.mdid8_status = 1571;
      }
      if (state == 2) {
        this.userCardSend.mdid8_status = 1572;
      }
      if (state == 3) {
        this.userCardSend.nickname = this.userCard.nickname;
        this.userCardSend.account_number = this.userCard.account_number;
      }
      if (state == 4) {
        this.userCardSend.is_business_partners = 1;
      }
      httpHelper
        .postData("confirmedshebacard", this.userCardSend)
        .then((res) => {
          if (res.success) {
            this.$makeToast('success','ذخیره موفق',"اطلاعات با موفقیت ذخیره گردید.",5000)
            this.$router.push("../sheba");
            //this.getdata();
          }
        });
    },
    getdata() {
      httpHelper
        .getData("usercards?id=" + this.$route.params.id)
        .then((res) => {
          this.userCard = res.result;
        });
    },
  },
};
</script>
